import { Box } from '@mui/material'
import { LeftPanelSection } from '../LeftPanel.styled'
import { useActions, useAppSelector } from 'hooks'
import { comparingCountries } from 'store/AIMetricOT/reducerSlice'
import SearchDropdown from 'components/common/SearchDropdown/SearchDropdown'
import { getCountryCodeByName, getCountryData, getCountryNameByCode } from 'utils/getCountryList'

function MultipleCountriesSelection() {
  const selectedCountries = useAppSelector(comparingCountries)
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const selectedCountriesForComparison = useAppSelector(comparingCountries)
  const { setComparingCountries } = useActions()

  const handleStateUpdate = (key: number, selection: string) => {
    if (selectedCountries !== undefined) {
      let newState = [...selectedCountries]
      newState[key] = selection
      setComparingCountries({ countries: newState })
    } else {
      setComparingCountries({ countries: [selection] })
    }
  }
  return (
    <LeftPanelSection header='Select countries'>
      <Box sx={{ display: 'flex', flexDirection: 'column'}}>
        {selectedCountries?.map((ele, index) => {
          const countryDataList = getCountryData(countryData)
          const currentCountryName = getCountryNameByCode(ele, countryDataList)
          const dataList = countryDataList.map((el) => {
            const countryCode = getCountryCodeByName(el.countryName, countryDataList)
            const isDisabled = countryCode ? selectedCountriesForComparison!.includes(countryCode) : false

            return {
              value: el.countryName,
              isDisabled,
            }
          })
          return (
            <SearchDropdown
              id={`country-dropdown-${index}`}
              size='small'
              value={currentCountryName}
              width={210}
              height={32}
              fontSize={15}
              key={index}
              handleStateUpdate={(event: React.SyntheticEvent, value: any) => {
                const currentCountryCode = getCountryCodeByName(value, countryDataList)
                if (currentCountryCode) {
                  if (index !== undefined && index !== null) {
                    handleStateUpdate(index, currentCountryCode)
                  }
                }
              }}
              data={dataList}
            />
          )
        })}
      </Box>
    </LeftPanelSection>
  )
}

export default MultipleCountriesSelection
